import { render, staticRenderFns } from "./TheSearchSpotLight.vue?vue&type=template&id=5d5a7ad4&scoped=true"
import script from "./TheSearchSpotLight.vue?vue&type=script&lang=js"
export * from "./TheSearchSpotLight.vue?vue&type=script&lang=js"
import style0 from "./TheSearchSpotLight.vue?vue&type=style&index=0&id=5d5a7ad4&prod&lang=css"
import style1 from "./TheSearchSpotLight.vue?vue&type=style&index=1&id=5d5a7ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5a7ad4",
  null
  
)

export default component.exports